import 'babel-polyfill';
import cookies from 'js-cookie';
import isNaN from 'lodash.isnan';

const elements = {
  notify: [...document.querySelectorAll('.js-notify')],
};

function closeHandler(e) {
  if (e.target.classList.contains('js-notify-close')) {
    const self = this;
    const parsedExpiry = parseInt(self.dataset.expires, 10);
    const expires = (parsedExpiry && isNaN(parsedExpiry) === false) ? {
      expires: parsedExpiry,
    } : {};

    self.setAttribute('hidden', '');
    self.classList.remove('is-active');
    cookies.set(self.dataset.cookie, true, expires);
  }
}

function bindClose(el) {
  el.removeAttribute('hidden');
  el.classList.add('is-active');
  el.scrollIntoView({ behavior: 'smooth' });
  el.addEventListener('click', closeHandler);
}

function checkForCookie(el) {
  if (Object.prototype.hasOwnProperty.call(el.dataset, 'cookie') && el.dataset.cookie !== '') {
    if (cookies.get(el.dataset.cookie) === undefined) {
      bindClose(el);
    }
  } else {
    bindClose(el);
  }
}

function init() {
  if (elements.notify.length > 0) {
    elements.notify.forEach(checkForCookie);
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/consumer/notify/notify.js